// extracted by mini-css-extract-plugin
export default {"formWrap":"formWrap-fAuQT","formWrapForm":"formWrap-form-gfCHz"};